import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { isMobile } from 'app/helpers/utils';

const P = styled.p`
  color: ${({ color }) => color};
  font-weight: ${({ weight }) => weight};
  font-size: ${({ size }) => size}px;
  line-height: ${({ lineHeight }) => lineHeight}px;
  text-align: ${({ textAlign }) => textAlign};
`;

P.defaultProps = {
  size: isMobile ? 16 : 14,
  lineHeight: isMobile ? 25 : 21,
  color: '#9a9b9f',
  weight: 300,
  textAlign: 'center',
};

P.propTypes = {
  weight: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
  lineHeight: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  textAlign: PropTypes.string.isRequired,
};

export default P;
